import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { findProductFromProductId } from "@qgiv/p2p-registration";
import { selectCurrentProductId } from "../../../../redux/slices/productModalSlice";
import { selectAllProducts } from "../../../../redux/slices/productsSlice";
import ProductImages from "./ProductImages";

const ConnectedProductImages = ({ displayImageCarrousel }) => {
    const currentProductId = useSelector(selectCurrentProductId);
    const products = useSelector(selectAllProducts);
    const product = findProductFromProductId(currentProductId, products);
    const { images, title, imgSrc } = product;

    const productImagesProps = {
        displayImageCarrousel,
        images,
        imgSrc,
        title,
    };

    return <ProductImages {...productImagesProps} />;
};

ConnectedProductImages.propTypes = {
    displayImageCarrousel: PropTypes.bool.isRequired,
};

export default ConnectedProductImages;
